import { firestore } from '../utils/firebase'
import { offerConverter } from '../data-contracts/Offer'

// ------------------------------------
// Constants
// ------------------------------------

const CREATE_OFFER = 'CREATE_OFFER'
const FETCH_OFFER = 'FETCH_OFFER'
const DELETE_OFFER = 'DELETE_OFFER'
const UPDATE_OFFER = 'UPDATE_OFFER'
const FILTER_OFFERS = 'FILTER_OFFERS'

const initialState = {
  offers: [],
}

const offerRef = firestore.collection('offers')

// ------------------------------------
// Actions
// ------------------------------------

export const createOffer = offer => dispatch =>
  new Promise(async (resolve, reject) => {
    try {
      offerRef
        .doc(offer.id)
        .withConverter(offerConverter)
        .set(offer)
        .then(() => {
          resolve(offer)
          dispatch({
            type: CREATE_OFFER,
            offer,
          })
        })
    } catch (err) {
      reject(err)
    }
  })

export const fetchOffer = offerId => dispatch =>
  new Promise(async (resolve, reject) => {
    try {
      offerRef.doc(offerId).onSnapshot(doc => {
        if (doc.exists) {
          dispatch({
            type: FETCH_OFFER,
            offer: doc.data(),
          })
          resolve(doc.data())
        } else {
          reject(new Error('No such document exists'))
        }
      })
    } catch (err) {
      reject(err)
    }
  })

export const findOffersToAuctions = auctionId => dispatch => {
  const auctionOffers = []

  return new Promise(async (resolve, reject) => {
    try {
      offerRef
        .where('auctionId', '==', auctionId)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            auctionOffers.push(doc.data())
          })

          resolve(auctionOffers)

          dispatch({
            type: FILTER_OFFERS,
            offers: auctionOffers,
          })
        })
    } catch (err) {
      reject(err)
    }
  })
}

export const updateOffer = offer => dispatch => {
  const docRef = offerRef.doc(offer.id)

  return new Promise(async (resolve, reject) => {
    try {
      docRef.update({ ...offer }).then(() => {
        resolve()
        dispatch({
          type: UPDATE_OFFER,
        })
      })
    } catch (err) {
      reject(err)
    }
  })
}

export const filterOffers = (field, value) => dispatch => {
  const offers = []

  return new Promise(async (resolve, reject) => {
    try {
      offerRef
        .where(field, '>=', value)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            offers.push(doc.data())
          })

          resolve(offers)

          dispatch({
            type: FILTER_OFFERS,
            offers,
          })
        })
    } catch (err) {
      reject(err)
    }
  })
}

export const filterOffersAcceptedForAuctions = auctionsIds => dispatch => {
  const offers = []

  return new Promise(async (resolve, reject) => {
    try {
      offerRef
        .where('auctionId', 'in', auctionsIds)
        .where('status', '==', 'accepted')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            offers.push(doc.data())
          })
          resolve(offers)

          dispatch({
            type: FILTER_OFFERS,
            offers,
          })
        })
    } catch (err) {
      reject(err)
    }
  })
}

export const deleteOffer = offerId => dispatch =>
  new Promise(async (resolve, reject) => {
    try {
      offerRef.doc(offerId).delete()

      dispatch({
        type: DELETE_OFFER,
      })
      resolve()
    } catch (err) {
      reject(err)
    }
  })

export const fetchOffers = () => dispatch => {
  const offers = []
  return new Promise(async (resolve, reject) => {
    try {
      offerRef.get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
          offers.push(doc.data())
        })
        resolve()
        dispatch({
          type: FETCH_OFFER,
          offers,
        })
      })
      resolve(offers)
    } catch (err) {
      reject(err)
    }
  })
}

export const actions = {
  createOffer,
  fetchOffer,
  fetchOffers,
  deleteOffer,
  updateOffer,
  filterOffers,
  findOffersToAuctions,
  filterOffersAcceptedForAuctions,
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_OFFER]: (state, { offer }) => ({
    ...state,
    offer,
  }),
  [FETCH_OFFER]: (state, { offer }) => ({
    ...state,
    offer,
  }),
  [FETCH_OFFER]: (state, { offer }) => ({
    ...state,
    offer,
  }),
  [DELETE_OFFER]: state => ({
    ...state,
  }),
  [UPDATE_OFFER]: state => ({
    ...state,
  }),
  [FILTER_OFFERS]: (state, { offers }) => ({
    ...state,
    offer: offers,
  }),
}

// ------------------------------------
// Reducer
// ------------------------------------

export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}
